module.exports = __webpack_public_path__ + "static/octupus-2-d3cb1a9911980e2992b02f74edc9d284.jpg";